<template>
  <div>
    <dashboard-header :text="$t('nav.permission')"/>
    
    <v-card
        elevation="0"
        class="card-border-10">

      <d-table
          class="pa-10"
          :table-data="items"
          :fields="fields"
          :loading="loading"
          :item-click="onItemTableClick"
          :edit="isEdit ? editItem : null"
          :on-delete="isDelete ? deleteItem : null"
          :add="isCreate ? addItem : null"
          :get-items="getItems"
          :custom-total-rows="totalRows"
          :on-delete-content="onDeleteContent"
      />
    </v-card>
  </div>
</template>

<script>
import {API2} from "../../api";
import mixin from "../../mixin";
import DashboardHeader from "../component/DashboardHeader";
import dTable from "../base/DataTable.vue";
import i18n from "../../lang/i18n";
import { PERMISSIONS } from "../../config/permissions";

export default {
  components: {DashboardHeader, dTable},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      // table
      items: [],
      totalRows: 0,
      optionParams: null,
      loading: false,
      search: '',
    };
  },
  mounted() {
    this.onTab()
  },
  computed: {
    isCreate() {
      return this.hasPermission(PERMISSIONS.ROLE_CREATE);
    },
    isEdit() {
      return this.hasPermission(PERMISSIONS.ROLE_UPDATE);
    },
    isDelete() {
      return false; // ROLE_DELETE không tồn tại
    },
    fields() {
      const baseFields = [
        {
          value: 'code',
          text: this.$t('permission.code')
        },
        {
          value: 'module',
          text: this.$t('permission.module')
        },
        {
          value: 'action',
          text: this.$t('permission.action')
        },
        {
          value: 'description',
          text: this.$t('permission.description')
        }
      ];
      
      // Chỉ hiển thị cột actions nếu có quyền edit hoặc delete
      if (this.isEdit || this.isDelete) {
        baseFields.push({
          value: 'actions'
        });
      }
      
      return baseFields;
    },
  },
  methods: {
    onTab() {
      this.getItems()
    },
    async getItems() {
      this.loading = true
      try {
        const response = await this.get(API2.PERMISSIONS)
        if (response && response.data && (response.data.status === 200 || response.data.code === 0)) {
          this.items = (response.data.data || []).map(permission => ({
            data: permission,
            code: permission.code,
            module: permission.module,
            action: permission.action,
            description: permission.description || '-'
          }))
          this.totalRows = this.items.length
        }
      } catch (error) {
        this.showToast('error', this.$t('common.loadError'))
      } finally {
        this.loading = false
      }
    },
    addItem() {
      this.openTab(1)
    },
    editItem(item) {
      this.openTab(1, item.data)
    },
    onItemTableClick(item) {
      if (this.checkPermissionOrShowError(PERMISSIONS.ROLE_VIEW)) {
        this.openTab(1, item.data)
      }
    },
    async deleteItem(item) {
      const confirmed = window.confirm(this.$t('permission.deleteConfirmMessage', { name: item.code }))
      
      if (confirmed) {
        try {
          const response = await this.delete2(`${API2.PERMISSIONS}/${item.data.id}`)
          if (response && response.data && (response.data.status === 200 || response.data.code === 0)) {
            this.showToast('success', this.$t('permission.deleteSuccess'))
            this.getItems()
          } else {
            this.showToast('error', response.data.message || this.$t('permission.deleteError'))
          }
        } catch (error) {
          this.showToast('error', this.$t('permission.deleteError'))
        }
      }
    },
    onDeleteContent(item) {
      return this.$t('permission.deleteConfirmMessage', { name: item.code })
    }
  }
};
</script>

<style></style>
